import { configureStore, combineReducers } from "@reduxjs/toolkit";

/* AUTH */
import authReducer from "../auth/authSlice";

/* ADMIN */
import branchReducer from "./admin/branch.slice";
import studentReducer from "./admin/student.slice";
import studentReportReducer from "./admin/studentReport.slice"; // ✅ Added
import studentPerformanceReducer from "./admin/studentPerformance.slice"; // ✅ Import new slice
import userAccountsReducer from "./admin/userAccounts.slice";
import feesReducer from "./admin/fees.slice";
import tournamentParticipantsReducer from "./admin/tournamentParticipants.slice";
import tournamentsReducer from "./admin/tournaments.slice";
import tournamentExpensesReducer from "./admin/tournamentExpenses.slice";
import tournamentExpenseCategoriesReducer from "./admin/tournamentExpenseCategories.slice";
import profitLossReducer from "./admin/profitLoss.slice";
import sessionMasterReducer from "./admin/sessionMaster.slice";
import sessionInfoReducer from "./admin/sessionInfo.slice";
import homeworkMasterReducer from "./admin/homeworkMaster.slice";
import homeworkSubmissionReducer from "./admin/homeworkSubmission.slice";
import courseCategoryReducer from "./admin/courseCategory.slice";
import courseInstructor from "./admin/courseInstructor.slice";
import bookReducer from "./admin/book.slice";

/* ADMIN DOMAIN */
const adminReducer = combineReducers({
  branches: branchReducer,
  students: studentReducer,
  studentReport: studentReportReducer, // ✅ Connected here for state.admin.studentReport
  studentPerformance: studentPerformanceReducer, // ✅ Added to admin object
  userAccounts: userAccountsReducer, // ✅ Added
  fees: feesReducer,
  tournamentParticipants: tournamentParticipantsReducer,
  tournaments: tournamentsReducer,
  courseCategory: courseCategoryReducer,
  book: bookReducer, // ✅ Added
  courseInstructor: courseInstructor,
  sessionMaster: sessionMasterReducer,
  homeworkMaster: homeworkMasterReducer,
  homeworkSubmission: homeworkSubmissionReducer,
  sessionInfo: sessionInfoReducer,
   // Tournament Expenses
  tournamentExpenses: tournamentExpensesReducer,
  tournamentExpenseCategories: tournamentExpenseCategoriesReducer,
  profitLoss: profitLossReducer, // ✅ ADD THIS
});

/* ROOT */
const rootReducer = combineReducers({
  auth: authReducer,
  admin: adminReducer,
});

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
